import { Navigate, useLocation } from "react-router-dom";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import AppShell from "~/shared/ui/AppShell";
import AccessDenied from "~/pages/AccessDenied";
import { saveReturnTo } from "./returnTo";
import { hasPermission } from "./permissions";
import { useAuth } from "./AuthProvider";

function RedirectToLogin() {
  const location = useLocation();
  // Idempotente: pode rodar duas vezes no StrictMode sem efeito colateral diferente.
  saveReturnTo(`${location.pathname}${location.search}`);
  return <Navigate to="/login" replace />;
}

export function AuthStatusGate({ children }) {
  const { status, reload } = useAuth();
  if (status === "loading") {
    return (
      <Box sx={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <CircularProgress aria-label="Carregando" />
      </Box>
    );
  }
  if (status === "error") {
    return (
      <Box sx={{ p: 3, maxWidth: 560, mx: "auto", mt: 8 }}>
        <Alert severity="error" action={<Button color="inherit" size="small" onClick={reload}>Tentar de novo</Button>}>
          <b>Não foi possível carregar seu acesso.</b> Verifique sua conexão e tente de novo.
        </Alert>
      </Box>
    );
  }
  if (status === "anonymous") return <RedirectToLogin />;
  return children;
}

const ForbiddenPage = () => <AccessDenied variant="forbidden" embedded />;

export default function PrivateRoute({ require, page }) {
  const { permissions } = useAuth();
  return (
    <AuthStatusGate>
      <AppShell Page={hasPermission(permissions, require) ? page : ForbiddenPage} />
    </AuthStatusGate>
  );
}
